export function circleHighlight() {
  const spans = document.querySelectorAll('.circle-highlight');
  if (!spans.length) return;

  const ns = 'http://www.w3.org/2000/svg';

  spans.forEach(span => {
    const parent = span.parentElement;

    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;overflow:visible;pointer-events:none;';

    const path = document.createElementNS(ns, 'path');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', '#1FEBD1');
    path.setAttribute('stroke-width', '6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');

    svg.appendChild(path);
    parent.appendChild(svg);

    const padX = 24;
    const padY = 10;

    function draw() {
      const rects = span.getClientRects();
      if (!rects.length) return;

      const parentRect = parent.getBoundingClientRect();
      // Use only the first line rect so multi-line spans still get a tight circle
      const r = rects[0];

      const x = r.left - parentRect.left - padX;
      const y = r.top - parentRect.top - padY;
      const w = r.width + padX * 2;
      const h = r.height + padY * 2;
      const cx = x + w / 2;
      const cy = y + h / 2;
      const rx = w / 2 - 3;
      const ry = h / 2 - 3;

      const d = [
        `M ${cx + rx},${cy - 4}`,
        `C ${cx + rx},${cy - ry * 0.65} ${cx + rx * 0.55},${cy - ry + 1} ${cx + 2},${cy - ry}`,
        `C ${cx - rx * 0.5},${cy - ry + 2} ${cx - rx},${cy - ry * 0.55} ${cx - rx},${cy + 2}`,
        `C ${cx - rx + 1},${cy + ry * 0.6} ${cx - rx * 0.5},${cy + ry - 1} ${cx},${cy + ry}`,
        `C ${cx + rx * 0.5},${cy + ry} ${cx + rx},${cy + ry * 0.6} ${cx + rx},${cy - 4}`,
      ].join(' ');

      path.setAttribute('d', d);
    }

    draw();

    const length = path.getTotalLength();
    path.style.strokeDasharray = `${length}`;
    path.style.strokeDashoffset = `${length}`;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          path.style.transition = 'stroke-dashoffset 1.4s cubic-bezier(0.4, 0, 0.2, 1)';
          path.style.strokeDashoffset = '0';
          observer.unobserve(span);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });

    observer.observe(span);
  });
}
